import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken, logOut} from '../../../helpers/LocalStorageHelper'
import {handleError} from "../../../helpers/ErrorHelper";

function _success(success) {
    return {type: 'GET_BACKUP_STATUS_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_BACKUP_STATUS_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_BACKUP_STATUS_PROCESSING', processing};
}

function getBackupStatus() {
    return (dispatch, getState) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));
        let {backupStatusList} = getState();
        let {params} = backupStatusList.data;

        axios({
            url: apiBaseUrl(`admin/backup-status-today`),
            method: "get",
            dataType: 'json',
            params,
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res.data.data));
                dispatch(_processing(false));
            }).catch(function (error) {
            handleError(error);
            dispatch(_error(error));
            dispatch(_processing(false));
        });


    }
}


export default getBackupStatus;